import PlayerListManager from "../../../managers/PlayerListManager";
import { fetchAPI } from "../../../config/api";

export async function fetchLists() {
  const response = await PlayerListManager.getUserPlayerLists();
  return Array.isArray(response) ? response : [];
}

export async function fetchListById(listId) {
  return PlayerListManager.getPlayerListById(listId);
}

export async function createList(name) {
  return PlayerListManager.createPlayerList({ name, description: "", playerIds: [] });
}

export async function deleteList(listId) {
  return PlayerListManager.deletePlayerList(listId);
}

export async function addPlayerToList(listId, playerIdStr) {
  return PlayerListManager.addPlayerToList(listId, playerIdStr);
}

export async function updateListPlayerIds(list, updatedIds) {
  return PlayerListManager.updatePlayerList({ ...list, playerIds: updatedIds });
}

export async function fetchAllPlayers() {
  const result = await fetchAPI("/api/players");
  if (!Array.isArray(result)) return [];
  return result.sort((a, b) =>
    String(a.player_name || "").localeCompare(String(b.player_name || ""))
  );
}

export async function fetchPlayersForList(listId) {
  const list = await fetchListById(listId);
  const ids = list?.playerIds || [];
  if (ids.length === 0) return [];
  const all = await fetchAPI("/api/players");
  return (Array.isArray(all) ? all : []).filter((p) =>
    ids.includes((p.player_id || "").toString())
  );
}
